import { createFileRoute, Navigate } from '@tanstack/react-router';
import { LoadingScreen } from '@/components/Layout/LoadingScreen';
import { useAuth } from '@/lib/authClient';

export const Route = createFileRoute('/')({
  component: Home,
});

function Home() {
  const { isAuthenticated, isPending } = useAuth();

  // Show loading while checking auth - this prevents the flash of login page
  if (isPending) {
    return <LoadingScreen message="Loading app..." />;
  }

  // Redirect based on authentication status
  if (isAuthenticated) {
    return <Navigate to="/deals" replace />;
  }

  return <Navigate to="/login" replace />;
}
